import { render } from "./p-date-range-widget.vue?vue&type=template&id=aafed8d4"
import script from "./p-date-range-widget.vue?vue&type=script&lang=js"
export * from "./p-date-range-widget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-date-range-widget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aafed8d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aafed8d4', __exports__)) {
    api.reload('aafed8d4', __exports__)
  }
  
  module.hot.accept("./p-date-range-widget.vue?vue&type=template&id=aafed8d4", () => {
    api.rerender('aafed8d4', render)
  })

}


export default __exports__